import React from "react";

import { Mic } from "lucide-react";
interface AudioMicButtonProps {
  isRecording: boolean;
}

const AudioMicButton: React.FC<AudioMicButtonProps> = ({ isRecording }) => (
  <div className="relative w-32 h-32 mb-5 ">
    {/* Animated outer ring - visible only when recording */}
    {isRecording && (
      <div className="absolute -inset-1 rounded-full animate-pulse-recording bg-primary/30  "></div>
    )}

    {/* Background circle */}
    <div className="absolute inset-0 rounded-full border-10 border-primary/50"></div>

    {/* Main circle around the mic icon - using primary color */}
    <div className="absolute inset-2 rounded-full flex items-center justify-center bg-primary text-white/70">
      <Mic className="h-12 w-12" />
    </div>

    {/* Animated accent dot indicator */}
    {isRecording && (
      <div className="absolute top-0 right-0">
        <div className="w-6 h-6 rounded-full bg-accent-bg-warm  border-3 border-accent-fg-warm"></div>
      </div>
    )}
  </div>
);

export default AudioMicButton;
